import { Check, X } from "lucide-react";

const rows = [
  ["Merchant Fee", "High (5–6% per transaction)", "Flat monthly rate"],
  ["Customer Debt", "Yes — credit checks & interest", "None — simple shared math"],
  ["Marketing Value", "None", "Viral referral loop"],
  ["Payout", "Upfront, minus high fees", "Upfront, full value"],
];

export function Comparison() {
  return (
    <section className="section bg-surface">
      <div className="container-tight">
        <div className="mx-auto max-w-2xl text-center">
          <span className="eyebrow">Splitkart vs BNPL</span>
          <h2 className="mt-3 text-2xl font-bold md:text-4xl">Same uplift. None of the baggage.</h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-2xl border border-border bg-card shadow-soft">
          <div className="overflow-x-auto">
            <div className="grid min-w-[720px] grid-cols-3 border-b border-border bg-secondary/40 text-xs font-semibold md:text-sm">
              <div className="px-4 py-3 text-muted-foreground md:px-6 md:py-4">Feature</div>
              <div className="px-4 py-3 text-foreground md:px-6 md:py-4">BNPL (Klarna / Affirm)</div>
              <div className="px-4 py-3 text-primary md:px-6 md:py-4">Splitkart</div>
            </div>
            {rows.map(([feature, bnpl, splitkart], i) => (
              <div key={feature} className={`grid min-w-[720px] grid-cols-3 text-xs md:text-sm ${i % 2 ? "bg-surface/40" : ""}`}>
                <div className="px-4 py-3 font-medium text-foreground md:px-6 md:py-4">{feature}</div>
                <div className="flex items-start gap-2 px-4 py-3 text-muted-foreground md:px-6 md:py-4">
                  <X className="mt-0.5 h-4 w-4 flex-shrink-0 text-destructive" />
                  <span>{bnpl}</span>
                </div>
                <div className="flex items-start gap-2 px-4 py-3 text-foreground md:px-6 md:py-4">
                  <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-success" />
                  <span>{splitkart}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
